export const features = {
  isCloudPortal: process.env.REACT_APP_PLATFORM === 'cloud',
  isOnpremisePortal: process.env.REACT_APP_PLATFORM === 'onpremise',
};
